import L, { Component as Q, PureComponent as Ot } from "react";
import h from "prop-types";
import { observer as M } from "mobx-react";
import { ContentSnippet as it, VSpacer as T, BannerAlert as ce, Icon as V, Text as W, Button as U, HSpacer as B, LoadingOverlay as ue, Card as de, ActionDropdown as he } from "@mqd/volt-base";
import { decorate as at, observable as j, action as b, computed as E, runInAction as fe } from "mobx";
import wt from "graphql-tag";
import { mergeColumnsWithStoredSettings as pe, TableHeader as ve, TableFilters as ge, ColumnEditor as ye, saveColumnConfig as _e, Pagination as me, mergeUserSetWidthIntoColumns as xe, ActionsHeader as be, clearColumnConfig as Ce } from "@mqd/volt-table";
var st = { exports: {} }, F = {}, Rt;
function Ee() {
  if (Rt)
    return F;
  Rt = 1;
  /** @license React v16.14.0
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var c = L, t = 60103;
  if (F.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var e = Symbol.for;
    t = e("react.element"), F.Fragment = e("react.fragment");
  }
  var n = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(d, v, y) {
    var C, S = {}, I = null, $ = null;
    y !== void 0 && (I = "" + y), v.key !== void 0 && (I = "" + v.key), v.ref !== void 0 && ($ = v.ref);
    for (C in v)
      s.call(v, C) && !o.hasOwnProperty(C) && (S[C] = v[C]);
    if (d && d.defaultProps)
      for (C in v = d.defaultProps, v)
        S[C] === void 0 && (S[C] = v[C]);
    return { $$typeof: t, type: d, key: I, ref: $, props: S, _owner: n.current };
  }
  return F.jsx = u, F.jsxs = u, F;
}
var nt = {}, At;
function je() {
  return At || (At = 1, function(c) {
    /** @license React v16.14.0
     * react-jsx-runtime.development.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    process.env.NODE_ENV !== "production" && function() {
      var t = L, e = 60103, n = 60106;
      c.Fragment = 60107;
      var s = 60108, o = 60114, u = 60109, d = 60110, v = 60112, y = 60113, C = 60120, S = 60115, I = 60116, $ = 60121, pt = 60122, vt = 60117, gt = 60129, yt = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var x = Symbol.for;
        e = x("react.element"), n = x("react.portal"), c.Fragment = x("react.fragment"), s = x("react.strict_mode"), o = x("react.profiler"), u = x("react.provider"), d = x("react.context"), v = x("react.forward_ref"), y = x("react.suspense"), C = x("react.suspense_list"), S = x("react.memo"), I = x("react.lazy"), $ = x("react.block"), pt = x("react.server.block"), vt = x("react.fundamental"), x("react.scope"), x("react.opaque.id"), gt = x("react.debug_trace_mode"), x("react.offscreen"), yt = x("react.legacy_hidden");
      }
      var _t = typeof Symbol == "function" && Symbol.iterator, Lt = "@@iterator";
      function Wt(r) {
        if (r === null || typeof r != "object")
          return null;
        var a = _t && r[_t] || r[Lt];
        return typeof a == "function" ? a : null;
      }
      var Y = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(r) {
        {
          for (var a = arguments.length, l = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            l[f - 1] = arguments[f];
          Ht("error", r, l);
        }
      }
      function Ht(r, a, l) {
        {
          var f = Y.ReactDebugCurrentFrame, m = "";
          if (H) {
            var _ = R(H.type), g = H._owner;
            m += Ft(_, H._source, g && R(g.type));
          }
          m += f.getStackAddendum(), m !== "" && (a += "%s", l = l.concat([m]));
          var p = l.map(function(P) {
            return "" + P;
          });
          p.unshift("Warning: " + a), Function.prototype.apply.call(console[r], console, p);
        }
      }
      var qt = !1;
      function Nt(r) {
        return !!(typeof r == "string" || typeof r == "function" || r === c.Fragment || r === o || r === gt || r === s || r === y || r === C || r === yt || qt || typeof r == "object" && r !== null && (r.$$typeof === I || r.$$typeof === S || r.$$typeof === u || r.$$typeof === d || r.$$typeof === v || r.$$typeof === vt || r.$$typeof === $ || r[0] === pt));
      }
      var J = /^(.*)[\\\/]/;
      function Ft(r, a, l) {
        var f = "";
        if (a) {
          var m = a.fileName, _ = m.replace(J, "");
          if (/^index\./.test(_)) {
            var g = m.match(J);
            if (g) {
              var p = g[1];
              if (p) {
                var P = p.replace(J, "");
                _ = P + "/" + _;
              }
            }
          }
          f = " (at " + _ + ":" + a.lineNumber + ")";
        } else
          l && (f = " (created by " + l + ")");
        return `
    in ` + (r || "Unknown") + f;
      }
      var Vt = 1;
      function Bt(r) {
        return r._status === Vt ? r._result : null;
      }
      function Mt(r, a, l) {
        var f = a.displayName || a.name || "";
        return r.displayName || (f !== "" ? l + "(" + f + ")" : l);
      }
      function R(r) {
        if (r == null)
          return null;
        if (typeof r.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof r == "function")
          return r.displayName || r.name || null;
        if (typeof r == "string")
          return r;
        switch (r) {
          case c.Fragment:
            return "Fragment";
          case n:
            return "Portal";
          case o:
            return "Profiler";
          case s:
            return "StrictMode";
          case y:
            return "Suspense";
          case C:
            return "SuspenseList";
        }
        if (typeof r == "object")
          switch (r.$$typeof) {
            case d:
              return "Context.Consumer";
            case u:
              return "Context.Provider";
            case v:
              return Mt(r, r.render, "ForwardRef");
            case S:
              return R(r.type);
            case $:
              return R(r.render);
            case I: {
              var a = r, l = Bt(a);
              if (l)
                return R(l);
              break;
            }
          }
        return null;
      }
      var mt = {};
      Y.ReactDebugCurrentFrame;
      var H = null;
      function K(r) {
        H = r;
      }
      function Yt(r, a, l, f, m) {
        {
          var _ = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var g in r)
            if (_(r, g)) {
              var p = void 0;
              try {
                if (typeof r[g] != "function") {
                  var P = Error((f || "React class") + ": " + l + " type `" + g + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[g] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw P.name = "Invariant Violation", P;
                }
                p = r[g](a, g, f, l, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (A) {
                p = A;
              }
              p && !(p instanceof Error) && (K(m), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", l, g, typeof p), K(null)), p instanceof Error && !(p.message in mt) && (mt[p.message] = !0, K(m), w("Failed %s type: %s", l, p.message), K(null));
            }
        }
      }
      var z = Y.ReactCurrentOwner, G = Object.prototype.hasOwnProperty, zt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, xt, bt, X;
      X = {};
      function Qt(r) {
        if (G.call(r, "ref")) {
          var a = Object.getOwnPropertyDescriptor(r, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return r.ref !== void 0;
      }
      function Kt(r) {
        if (G.call(r, "key")) {
          var a = Object.getOwnPropertyDescriptor(r, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return r.key !== void 0;
      }
      function Jt(r, a) {
        if (typeof r.ref == "string" && z.current && a && z.current.stateNode !== a) {
          var l = R(z.current.type);
          X[l] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', R(z.current.type), r.ref), X[l] = !0);
        }
      }
      function Gt(r, a) {
        {
          var l = function() {
            xt || (xt = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          l.isReactWarning = !0, Object.defineProperty(r, "key", {
            get: l,
            configurable: !0
          });
        }
      }
      function Xt(r, a) {
        {
          var l = function() {
            bt || (bt = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          l.isReactWarning = !0, Object.defineProperty(r, "ref", {
            get: l,
            configurable: !0
          });
        }
      }
      var Zt = function(r, a, l, f, m, _, g) {
        var p = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: e,
          // Built-in properties that belong on the element
          type: r,
          key: a,
          ref: l,
          props: g,
          // Record the component responsible for creating this element.
          _owner: _
        };
        return p._store = {}, Object.defineProperty(p._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(p, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(p, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: m
        }), Object.freeze && (Object.freeze(p.props), Object.freeze(p)), p;
      };
      function te(r, a, l, f, m) {
        {
          var _, g = {}, p = null, P = null;
          l !== void 0 && (p = "" + l), Kt(a) && (p = "" + a.key), Qt(a) && (P = a.ref, Jt(a, m));
          for (_ in a)
            G.call(a, _) && !zt.hasOwnProperty(_) && (g[_] = a[_]);
          if (r && r.defaultProps) {
            var A = r.defaultProps;
            for (_ in A)
              g[_] === void 0 && (g[_] = A[_]);
          }
          if (p || P) {
            var D = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
            p && Gt(g, D), P && Xt(g, D);
          }
          return Zt(r, p, P, m, f, z.current, g);
        }
      }
      var Z = Y.ReactCurrentOwner;
      Y.ReactDebugCurrentFrame;
      function q(r) {
        H = r;
      }
      var tt;
      tt = !1;
      function et(r) {
        return typeof r == "object" && r !== null && r.$$typeof === e;
      }
      function Ct() {
        {
          if (Z.current) {
            var r = R(Z.current.type);
            if (r)
              return `

Check the render method of \`` + r + "`.";
          }
          return "";
        }
      }
      function ee(r) {
        return "";
      }
      var Et = {};
      function re(r) {
        {
          var a = Ct();
          if (!a) {
            var l = typeof r == "string" ? r : r.displayName || r.name;
            l && (a = `

Check the top-level render call using <` + l + ">.");
          }
          return a;
        }
      }
      function jt(r, a) {
        {
          if (!r._store || r._store.validated || r.key != null)
            return;
          r._store.validated = !0;
          var l = re(a);
          if (Et[l])
            return;
          Et[l] = !0;
          var f = "";
          r && r._owner && r._owner !== Z.current && (f = " It was passed a child from " + R(r._owner.type) + "."), q(r), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', l, f), q(null);
        }
      }
      function Pt(r, a) {
        {
          if (typeof r != "object")
            return;
          if (Array.isArray(r))
            for (var l = 0; l < r.length; l++) {
              var f = r[l];
              et(f) && jt(f, a);
            }
          else if (et(r))
            r._store && (r._store.validated = !0);
          else if (r) {
            var m = Wt(r);
            if (typeof m == "function" && m !== r.entries)
              for (var _ = m.call(r), g; !(g = _.next()).done; )
                et(g.value) && jt(g.value, a);
          }
        }
      }
      function ne(r) {
        {
          var a = r.type;
          if (a == null || typeof a == "string")
            return;
          var l;
          if (typeof a == "function")
            l = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === v || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === S))
            l = a.propTypes;
          else
            return;
          if (l) {
            var f = R(a);
            Yt(l, r.props, "prop", f, r);
          } else if (a.PropTypes !== void 0 && !tt) {
            tt = !0;
            var m = R(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", m || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function se(r) {
        {
          for (var a = Object.keys(r.props), l = 0; l < a.length; l++) {
            var f = a[l];
            if (f !== "children" && f !== "key") {
              q(r), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), q(null);
              break;
            }
          }
          r.ref !== null && (q(r), w("Invalid attribute `ref` supplied to `React.Fragment`."), q(null));
        }
      }
      function St(r, a, l, f, m, _) {
        {
          var g = Nt(r);
          if (!g) {
            var p = "";
            (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (p += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var P = ee();
            P ? p += P : p += Ct();
            var A;
            r === null ? A = "null" : Array.isArray(r) ? A = "array" : r !== void 0 && r.$$typeof === e ? (A = "<" + (R(r.type) || "Unknown") + " />", p = " Did you accidentally export a JSX literal instead of a component?") : A = typeof r, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, p);
          }
          var D = te(r, a, l, m, _);
          if (D == null)
            return D;
          if (g) {
            var N = a.children;
            if (N !== void 0)
              if (f)
                if (Array.isArray(N)) {
                  for (var rt = 0; rt < N.length; rt++)
                    Pt(N[rt], r);
                  Object.freeze && Object.freeze(N);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Pt(N, r);
          }
          return r === c.Fragment ? se(D) : ne(D), D;
        }
      }
      function ie(r, a, l) {
        return St(r, a, l, !0);
      }
      function ae(r, a, l) {
        return St(r, a, l, !1);
      }
      var oe = ae, le = ie;
      c.jsx = oe, c.jsxs = le;
    }();
  }(nt)), nt;
}
process.env.NODE_ENV === "production" ? st.exports = Ee() : st.exports = je();
var i = st.exports;
const Pe = {
  display: "flex",
  alignItems: "center",
  paddingTop: "2px"
};
class ot extends L.Component {
  render() {
    const {
      active: t,
      editActive: e,
      isEditable: n,
      onChange: s,
      tooltipContent: o,
      tooltipProps: u,
      testId: d
    } = this.props, v = t ? "Active" : "Inactive";
    return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx(it, { title: "Status", horizontalLayout: !0, editActive: n ? e : !1, inputType: "toggle", inputValue: t, inputProps: {
        toggleText: v
      }, onChange: s, tooltipContent: o, tooltipProps: u, testId: `${d}_content-snippet`, children: /* @__PURE__ */ i.jsx("div", { style: Pe, "data-testid": `${d}_status-wrapper`, children: /* @__PURE__ */ i.jsx(Me, { status: v }) }) }),
      /* @__PURE__ */ i.jsx(T, { factor: e ? 1 : 2 })
    ] });
  }
}
ot.propTypes = {
  active: h.bool,
  editActive: h.bool,
  isEditable: h.bool,
  onChange: h.func,
  tooltipContent: h.any,
  tooltipProps: h.object
};
ot.defaultProps = {
  active: !0,
  editActive: !1,
  isEditable: !0,
  onChange: () => {
  },
  tooltipContent: null,
  tooltipProps: {
    direction: "right"
  }
};
const Se = M(ot);
function dr(c, t = "100%") {
  return class extends Q {
    constructor(e) {
      super(e), this.state = {
        containerWidth: null
      }, this.resizeEventListener = null, this.updateWidth = this.updateWidth.bind(this), this.container = L.createRef();
    }
    componentDidMount() {
      window.addEventListener("resize", this.updateWidth), this.setState({
        containerWidth: this.container.current.offsetWidth
      });
    }
    componentWillUnmount() {
      window.removeEventListener("resize", this.updateWidth);
    }
    updateWidth() {
      clearTimeout(this.resizeEventListener), this.resizeEventListener = setTimeout(this.setState({
        containerWidth: this.container.current.offsetWidth
      }), 200);
    }
    render() {
      const {
        containerWidth: e
      } = this.state;
      return /* @__PURE__ */ i.jsx("div", { ref: this.container, style: {
        width: t
      }, children: /* @__PURE__ */ i.jsx(c, { ...this.props, containerWidth: e }) });
    }
  };
}
function hr(c, t = "0") {
  return class extends Q {
    constructor(e) {
      super(e), this.state = {
        height: 0
      }, this.updateHeight = this.updateHeight.bind(this);
    }
    componentDidMount() {
      this.updateHeight(), window.addEventListener("resize", this.updateHeight);
    }
    componentWillUnmount() {
      window.removeEventListener("resize", this.updateHeight);
    }
    updateHeight() {
      const e = window.innerHeight - t;
      this.setState({
        height: e
      });
    }
    render() {
      const {
        height: e
      } = this.state;
      return /* @__PURE__ */ i.jsx(c, { ...this.props, dynamicHeight: e });
    }
  };
}
const we = "_wrap_aq739_1", Re = "_dismiss_aq739_5", Tt = {
  wrap: we,
  dismiss: Re
};
class lt extends Q {
  constructor(t) {
    super(t), this.dismissAlert = this.dismissAlert.bind(this), this.ref = L.createRef();
  }
  componentDidUpdate() {
    this.ref.current && window.scrollTo({
      top: this.ref.current.offsetTop - 40,
      behavior: "smooth"
    });
  }
  dismissAlert() {
    const {
      store: t
    } = this.props;
    if (!t)
      return null;
    const {
      setAttr: e
    } = t;
    e("error", null);
  }
  render() {
    const {
      store: t
    } = this.props;
    return !t || !t.error ? null : /* @__PURE__ */ i.jsxs("div", { className: Tt.wrap, ref: this.ref, children: [
      /* @__PURE__ */ i.jsxs(ce, { size: "sm", type: "danger", heading: "We're sorry, there was an API error", children: [
        /* @__PURE__ */ i.jsx("div", { className: Tt.dismiss, onClick: this.dismissAlert, children: /* @__PURE__ */ i.jsx(V, { type: "close" }) }),
        /* @__PURE__ */ i.jsx(W, { children: t.error })
      ] }),
      /* @__PURE__ */ i.jsx(T, { factor: 2 })
    ] });
  }
}
lt.propTypes = {
  store: h.any
};
lt.defaultProps = {
  store: {}
};
const fr = M(lt);
function ct({
  title: c = "",
  content: t,
  onChange: e,
  editActive: n,
  inputType: s = "input",
  inputValue: o,
  inputProps: u = {},
  tooltipContent: d,
  tooltipProps: v = {},
  isEditable: y,
  testId: C
}) {
  const S = t || /* @__PURE__ */ i.jsx(W, { mod: "light", children: "--" });
  return s === "select" && !u.placeholder && (u.placeholder = `Select ${c}`), u.placeholder || (u.placeholder = `Enter ${c}`), /* @__PURE__ */ i.jsxs("div", { "data-testid": C, children: [
    /* @__PURE__ */ i.jsx(it, { inputType: s, inputValue: o, editActive: y ? n : !1, title: c, horizontalLayout: !0, tooltipContent: d, tooltipProps: v, onChange: e, inputProps: u, testId: `${C}_content-snippet`, children: S }),
    /* @__PURE__ */ i.jsx(T, { factor: n ? 1 : 2 })
  ] });
}
ct.propTypes = {
  title: h.string,
  content: h.string,
  onChange: h.func,
  editActive: h.bool,
  isEditable: h.bool,
  inputType: h.string,
  inputValue: h.any,
  inputProps: h.object,
  tooltipContent: h.any,
  tooltipProps: h.object,
  testId: h.string
};
ct.defaultProps = {
  title: "",
  content: null,
  onChange: null,
  editActive: !1,
  isEditable: !0,
  inputType: "input",
  inputValue: void 0,
  inputProps: {},
  tooltipContent: null,
  tooltipProps: {},
  testId: "info-field-item"
};
class ut extends L.Component {
  render() {
    const {
      items: t = [],
      store: e,
      editActive: n,
      testId: s
    } = this.props, o = t.length, u = t && t.map((d, v) => d.inputType === "active" ? d.content || /* @__PURE__ */ i.jsxs("div", { "data-testid": `${s}_active-field-wrapper`, children: [
      /* @__PURE__ */ i.jsx(Se, { store: e, active: e.active, onChange: (y) => e.updateForSave("active", y), editActive: n, tooltipContent: d.tooltipContent, isEditable: d.isEditable, tooltipProps: d.tooltipProps, testId: `${s}_active-field` }),
      v === o - 1 ? null : /* @__PURE__ */ i.jsx(T, { factor: 1 })
    ] }) : /* @__PURE__ */ i.jsxs("div", { "data-testid": s, children: [
      /* @__PURE__ */ i.jsx(ct, { title: d.title, content: d.content || e[d.accessor], onChange: (y) => e.updateForSave(d.accessor, y.target.value), editActive: n, isEditable: d.isEditable, inputType: d.inputType, inputProps: d.inputProps, tooltipContent: d.tooltipContent, testId: `${s}_info-field-item-${d.accessor}` }, d.title),
      v === o - 1 ? null : /* @__PURE__ */ i.jsx(T, { factor: 1 })
    ] }));
    return /* @__PURE__ */ i.jsx(i.Fragment, { children: u });
  }
}
ut.propTypes = {
  editActive: h.bool,
  items: h.array,
  store: h.object,
  testId: h.string
};
ut.defaultProps = {
  editActive: !1,
  items: [],
  store: {},
  testId: "info-field-list"
};
const Ae = M(ut);
class dt extends L.Component {
  constructor(t) {
    super(t), this.state = {
      loading: !1,
      editActive: !1
    }, this.handleSave = this.handleSave.bind(this), this.handleCancel = this.handleCancel.bind(this);
  }
  componentWillUnmount() {
    this.handleCancel();
  }
  get store() {
    const {
      store: t = {}
    } = this.props;
    return t;
  }
  async handleSave() {
    const {
      updateResource: t
    } = this.store;
    this.setState({
      loading: !0
    });
    try {
      await t(), this.setState({
        loading: !1,
        editActive: !1
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.state.loading && this.setState({
        loading: !1
      });
    }
  }
  handleCancel() {
    const {
      revertUpdates: t
    } = this.store;
    t && t(), this.setState({
      editActive: !1
    });
  }
  renderHeaderButtons() {
    const {
      testId: t
    } = this.props, e = {
      display: "flex",
      alignItems: "center"
    };
    return /* @__PURE__ */ i.jsxs("div", { style: e, children: [
      /* @__PURE__ */ i.jsx(U, { type: "outline", onClick: this.handleCancel, testId: `${t}_cancel-button`, children: "Cancel" }),
      /* @__PURE__ */ i.jsx(B, {}),
      /* @__PURE__ */ i.jsx(U, { onClick: this.handleSave, testId: `${t}_save-button`, children: "Save" })
    ] });
  }
  renderControl() {
    const {
      testId: t
    } = this.props, e = {
      marginTop: "-3px",
      cursor: "pointer"
    };
    return /* @__PURE__ */ i.jsx("div", { style: e, "data-testid": `${t}_control-icon`, children: /* @__PURE__ */ i.jsx(V, { onClick: () => this.setState({
      editActive: !0
    }), type: "edit", factor: 0.8333 }) });
  }
  render() {
    const {
      editActive: t,
      loading: e
    } = this.state, {
      title: n,
      items: s,
      testId: o
    } = this.props;
    return /* @__PURE__ */ i.jsx(ue, { active: e, children: /* @__PURE__ */ i.jsx(de, { title: n, contentPadding: "24px", controls: t ? this.renderHeaderButtons() : this.renderControl(), testId: `${o}_card`, noBoxShadow: !0, children: /* @__PURE__ */ i.jsx(Ae, { editActive: t, items: s, store: this.store, testId: o }) }) });
  }
}
dt.propTypes = {
  items: h.array,
  store: h.object,
  title: h.string,
  testId: h.string
};
dt.defaultProps = {
  items: [],
  store: {},
  title: "",
  testId: "info-card"
};
const pr = M(dt);
class $t {
  constructor({
    gqlClient: t
  }) {
    this.error = null, this.loading = !1, this.valuesUpdated = {}, this.isMobxStore = !0, this.constructedBy = null, this.paramsBlacklist = ["count", "start_index"], this.watchedObjects = [], this.gqlClient = t;
  }
  // actions
  async gqlMutation(t, e, n = [], s = "no-cache", o = "none") {
    if (t = wt`
      ${t}
    `, !this.gqlClient)
      throw new Error(`No gqlClient defined for ${this.constructor ? this.constructor.name : "Unknown Class"}`);
    this.error = null;
    try {
      return await this.gqlClient.mutate({
        mutation: t,
        variables: e,
        fetchPolicy: s,
        errorPolicy: o
      });
    } catch (u) {
      this.handleError(u);
    }
  }
  async gqlQuery(t, e, n = [], s = "no-cache", o = "none") {
    if (t = wt`
      ${t}
    `, !this.gqlClient)
      throw new Error(`No gqlClient defined for ${this.constructor ? this.constructor.name : "Unknown Class"}`);
    this.error = null;
    try {
      return await this.gqlClient.query({
        query: t,
        variables: e,
        fetchPolicy: s,
        errorPolicy: o
      });
    } catch (u) {
      this.handleError(u);
    }
  }
  handleError(t) {
    fe(() => {
      const e = t.message.split("GraphQL error: ")[1];
      this.error = e, console.error(t);
    });
  }
  setAttr(t, e) {
    this[t] = e;
  }
  getAttr(t) {
    return this[t];
  }
  setAttrWithLimit(t, e, n) {
    e.length > n || (this[t] = e);
  }
  load(t) {
    for (const e in t)
      this[e] = t[e];
  }
  updateForSave(t, e) {
    if (!(t in this.valuesUpdated)) {
      const n = Object.assign({}, this.valuesUpdated);
      n[t] = this[t], this.valuesUpdated = n;
    }
    this[t] = e;
  }
  // Use the stored original values in
  // this.valuesUpated to revert
  revertUpdates(t = !0) {
    for (const e in this.valuesUpdated) {
      const n = this.valuesUpdated[e];
      this[e] = n;
    }
    this.valuesUpdated = {}, t && this.watchedObjects && this.watchedObjects.length && this.watchedObjects.forEach((e) => {
      const n = this[e];
      n && n.revertUpdates && n.revertUpdates();
    });
  }
  loadAndConstructList(t, e, n) {
    if (e) {
      if (!Array.isArray(e))
        return console.error(`Invalid items array for ${t} - ${e}`), [];
      if (!n)
        return console.error(`Item store not defined for ${t}`), [];
      this[t] = e.map((s) => {
        const o = new n(s);
        return o.skipAutoLoad || o.load(s), this.gqlClient && o.setAttr("gqlClient", this.gqlClient), o.constructedBy = this, o;
      });
    }
  }
  loadAndConstructItem(t, e, n) {
    const s = e ? new n(e) : new n();
    this.gqlClient && s.setAttr("gqlClient", this.gqlClient), s.constructedBy = this, this[t] = s;
  }
  parseDelimitedParams(t, e) {
    const n = this.hydrateParams;
    return t.forEach((s) => {
      this[s] instanceof Array && this[s].length > 0 && (n[s] = this[s].join(e));
    }), n;
  }
  // computed
  get hydrateParams() {
    const t = {};
    for (const e in this.queryParams) {
      const n = this.queryParams[e];
      t[e] = n.val;
    }
    return t;
  }
  get outerQueryParams() {
    if (!this.queryParams)
      return "";
    let t = "";
    for (const e in this.queryParams) {
      if (this.paramsBlacklist.includes(e))
        continue;
      const n = this.queryParams[e];
      this.valDefinedOnObject(n) && (t += `$${e}: ${n.type} `);
    }
    return this.paginationParamsOuter && (t += this.paginationParamsOuter), t ? `(${t})` : "";
  }
  get innerQueryParams() {
    if (!this.queryParams)
      return "";
    let t = "";
    for (const e in this.queryParams)
      this.paramsBlacklist.includes(e) || this.valDefinedOnObject(this.queryParams[e]) && (t += `${e}: $${e} `);
    return this.paginationParamsInner && (t += this.paginationParamsInner), t ? `(${t})` : "";
  }
  get updatesObject() {
    const t = {};
    return this.valuesUpdatedArray.forEach((e) => {
      t[e] = this[e];
    }), t;
  }
  get updateParams() {
    const t = {};
    return this.valuesUpdatedArray.length === 0 ? null : (this.valuesUpdatedArray.forEach((e) => {
      t[e] = this[e];
    }), t);
  }
  get watchedUpdateParams() {
    const t = {};
    return this.watchedObjects.forEach((e) => {
      this[e] && this[e].updateParams && (t[e] = this[e].updateParams);
    }), t;
  }
  get valuesUpdatedArray() {
    return this.valuesUpdated ? Object.keys(this.valuesUpdated) : [];
  }
  get valuesAreUpdated() {
    return this.valuesUpdatedArray.length !== 0;
  }
  // helpers
  ensureBoolean(t) {
    switch (typeof t) {
      case "boolean":
        return t;
      case "string":
        if (t === "")
          return;
        const e = ["true", "active"], n = ["", "false", "inactive"], s = ["all"];
        return e.includes(t) ? !0 : n.includes(t) ? !1 : s.includes(t) ? void 0 : (console.error("ERROR: unable to convert string to boolean."), t);
      default:
        return t;
    }
  }
  /**
   * Configures the outer query params for GraphQL query
   *
   * @param {Object} paramsInfo - object that maps param name to corresponding type and value
   * (e.g. paramsInfo = { token: { type: 'String', val: 'user123' } })
   * @return {String} - string that is passed as outer query params for GraphQL query
   * (.e.g '$token: String')
   */
  configureOuterQueryParams(t) {
    return Object.keys(t).map((e) => {
      const n = t[e].type;
      return `$${e}: ${n}`;
    }).join(" ");
  }
  /**
   * Configures the inner query params for GraphQL query
   *
   * @param {Object} paramsInfo - object that maps param name to corresponding type and value
   * (e.g. paramsInfo = { token: { type: 'String', val: 'user123' } })
   * @return {String} - string that is passed as inner query params for GraphQL query
   * (.e.g 'token: $token')
   */
  configureInnerQueryParams(t) {
    return Object.keys(t).map((e) => `${e}: $${e}`).join(" ");
  }
  /**
   * Configures the query params for GraphQL query
   *
   * @param {Object} paramsInfo - object that maps param name to corresponding type and value
   * (e.g. paramsInfo = { token: { type: 'String', val: 'user123' } })
   * @return {Object} - object that maps param name to corresponding value
   * (.e.g { token: 'user123' })
   */
  configureQueryParams(t) {
    const e = {};
    return Object.keys(t).forEach((n) => {
      typeof t[n].val < "u" && (e[n] = t[n].val);
    }), e;
  }
  extract(t, e) {
    return t && t.data && t.data[e] ? t.data[e] : {};
  }
  valDefinedOnObject(t) {
    return !!t.val;
  }
  /**
   * Does exactly what ruby dig() does.
   * Attempts to find a nested value, if it's not found returns undefined
   */
  dig(t, ...e) {
    let n = t;
    for (const s of e) {
      if (typeof n > "u" || n === null)
        return;
      typeof s == "function" ? n = s(n) : n = n[s];
    }
    return n;
  }
  uniqueArray(t) {
    return [...new Set(t)];
  }
}
at($t, {
  // values
  gqlClient: j,
  error: j,
  loading: j,
  valuesUpdated: j,
  constructedBy: j,
  // actions
  gqlQuery: b.bound,
  gqlMutation: b.bound,
  handleError: b.bound,
  setAttr: b.bound,
  getAttr: b.bound,
  load: b.bound,
  updateForSave: b.bound,
  revertUpdates: b.bound,
  loadAndConstructList: b.bound,
  loadAndConstructItem: b.bound,
  parseDelimitedParams: b.bound,
  setAttrWithLimit: b.bound,
  uniqueArray: b.bound,
  // computed
  outerQueryParams: E,
  innerQueryParams: E,
  updatesObject: E,
  hydrateParams: E,
  updateParams: E,
  watchedUpdateParams: E,
  valuesUpdatedArray: E,
  valuesAreUpdated: E
});
class Dt extends $t {
  constructor(...t) {
    super(...t), this.count = null, this.start_index = 0, this.end_index = null, this.is_more = !1, this.paginationAttributes = `
    count
    start_index
    end_index
    is_more
  `, this.paginationParamsOuter = "$count: Int $start_index: Int", this.paginationParamsInner = `
    count: $count
    start_index: $start_index
  `;
  }
  // actions
  nextPage() {
    this.start_index += this.count;
  }
  prevPage() {
    this.start_index -= this.count;
  }
  // computed
  get paginationParams() {
    return {
      count: this.count,
      start_index: this.start_index
    };
  }
  get paginationText() {
    const t = this.start_index + 1, e = this.end_index;
    return this.count ? `Showing ${t} to ${e || "..."}` : "No Result";
  }
  get prevPageAvailable() {
    return this.count && this.start_index - this.count >= 0;
  }
  get is_less() {
    return this.prevPageAvailable;
  }
  get startIndexDisplay() {
    return this.start_index + 1;
  }
  get endIndexDisplay() {
    return this.end_index ? this.end_index + 1 : 0;
  }
}
at(Dt, {
  // values
  count: j,
  start_index: j,
  end_index: j,
  is_more: j,
  // actions
  nextPage: b.bound,
  prevPage: b.bound,
  // computed
  paginationParams: E,
  paginationText: E,
  prevPageAvailable: E,
  is_less: E,
  startIndexDisplay: E,
  endIndexDisplay: E
});
class kt extends Q {
  componentDidMount() {
    this.instantiateStore(this.props);
  }
  instantiateStore(t) {
    const {
      store: e,
      skipStoreConstruction: n
    } = this.props;
    if (n)
      return null;
    let s = null;
    if (e)
      s = e;
    else {
      if (!this.storeConstructor)
        return console.error("Add this.storeConstructor = <your resource constructor class> to your Voltron+ Component constructor"), {};
      s = new this.storeConstructor(t.storeInitArgs), typeof t.onStoreConstruction == "function" && t.onStoreConstruction(s);
    }
    return this._store = s, !e && t.autoHydrate && this._store.hydrate(), s;
  }
  instantiateAdditionalStore(t, e, n) {
    if (!n.token)
      return this[t] = {};
    if (this[t])
      console.error("storeKey namespace is already taken");
    else {
      const {
        gqlClient: o
      } = this.props.storeInitArgs;
      this[t] = new e({
        gqlClient: o,
        ...n
      }), this[t].hydrate();
    }
  }
  get store() {
    const {
      store: t
    } = this.props;
    return t || (this._store ? this._store : this.instantiateStore(this.props));
  }
}
class vr extends kt {
  constructor(t) {
    super(t), this.state = {
      tableHeight: 0
    }, this.updateTableHeight = this.updateTableHeight.bind(this);
  }
  componentDidMount() {
    this.updateTableHeight(), window.addEventListener("resize", this.updateTableHeight);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateTableHeight);
  }
  updateTableHeight() {
    const y = window.innerHeight - 336 - 18;
    this.setState({
      tableHeight: y
    });
  }
  get dynamicHeight() {
    return this.state.tableHeight;
  }
  get inactiveTab() {
    const {
      activeTab: t
    } = this.state;
    return !this.activeTabs[t];
  }
}
const Te = (c, t) => {
  window.analytics && window.analytics.track(c, t);
};
function Ie(c) {
  const {
    children: t,
    eventName: e,
    eventProperties: n
  } = c;
  return /* @__PURE__ */ i.jsx("div", { onClick: () => Te(e, n), children: t });
}
class gr extends Q {
  getHeaderButtons(t) {
    return /* @__PURE__ */ i.jsxs("div", { style: {
      display: "flex",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ i.jsx(U, { type: "outline", onClick: () => this.setState({
        editActive: !1
      }), children: "Cancel" }),
      /* @__PURE__ */ i.jsx(B, {}),
      /* @__PURE__ */ i.jsx(U, { onClick: t, children: "Save" })
    ] });
  }
  renderControl() {
    return /* @__PURE__ */ i.jsx(V, { onClick: () => this.setState({
      editActive: !0
    }), type: "edit", factor: 0.8333 });
  }
  renderSsnRevealButton({
    canReveal: t,
    value: e = "",
    reveal: n,
    hide: s,
    editActive: o
  }) {
    if (t === void 0)
      return console.error("canReveal is required to render reveal button");
    if (!t || !e || o)
      return null;
    const u = !e.includes("*"), d = u ? s : n;
    return /* @__PURE__ */ i.jsx(U, { type: "outline", onClick: d, children: u ? "Hide" : "Reveal" });
  }
  renderChangeStatusButton(t, e) {
    const {
      canMakeTransition: n
    } = this.props;
    return n ? /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx(B, {}),
      /* @__PURE__ */ i.jsx("div", { "data-testid": "change-status-button", style: {
        cursor: "pointer"
      }, onClick: () => this.setState({
        showChangeStatusModal: !0
      }), children: /* @__PURE__ */ i.jsx(Ie, { eventName: t, eventProperties: e, children: /* @__PURE__ */ i.jsx(U, { size: "xs", type: "outline", children: "Change" }) }) })
    ] }) : null;
  }
  //TODO: pull out renderSnippet into it's own component that accepts the args as props
  renderSnippet({
    title: t,
    heading: e,
    content: n,
    editActive: s,
    inputType: o = "input",
    inputProps: u = {},
    inputValue: d,
    tooltipContent: v,
    tooltipProps: y = {},
    onChange: C
  }) {
    const S = n || /* @__PURE__ */ i.jsx(W, { type: "body-sm", children: "--" });
    o === "select" && !u.placeholder && (u.placeholder = `Select ${t}`), u.placeholder || (u.placeholder = `Enter ${t}`), y = Object.assign({}, y, {
      zIndex: 9999
    });
    const I = s ? null : {
      width: 180
    }, $ = s ? null : {
      flexGrow: 1
    };
    return /* @__PURE__ */ i.jsxs("div", { children: [
      /* @__PURE__ */ i.jsx(it, { testId: `volt-content-snippet_title-${t}${e ? `_heading-${e}` : ""}`, inputType: o, inputValue: d, editActive: s, title: t, horizontalLayout: !0, tooltipContent: v, tooltipProps: y, onChange: C, inputProps: u, titleInline: I, contentInline: $, children: S }),
      /* @__PURE__ */ i.jsx(T, { factor: s ? 1 : 2 })
    ] });
  }
}
class yr extends kt {
  constructor(...t) {
    super(...t), this.clearFilterFunc = () => {
    };
  }
  colEditState(t, e) {
    return {
      tableKey: "",
      columns: pe(e, t.localStorageKey),
      showColumnEditor: !1
    };
  }
  get tableParentType() {
    try {
      const {
        storeInitArgs: {
          tableParentType: t
        }
      } = this.props;
      return t;
    } catch {
    }
  }
  renderColEditTableHeader({
    filterOptions: t,
    tableFilterTestId: e,
    customTableFilter: n,
    filterProps: s = {}
  }) {
    const {
      localStorageKey: o,
      excludedFilters: u
    } = this.props, {
      columns: d,
      showColumnEditor: v
    } = this.state;
    return /* @__PURE__ */ i.jsxs(ve, { children: [
      n || /* @__PURE__ */ i.jsx(ge, { store: this.store, filterOptions: t, excludedFilters: u, testId: e, receiveClearFilterFunc: (y) => this.clearFilterFunc = y, type: "large", ...s }),
      v && /* @__PURE__ */ i.jsx(ye, { columns: d, handleSave: (y) => {
        _e(y, o), this.setState({
          columns: y
        }, () => {
          this.setState({
            tableKey: `${/* @__PURE__ */ new Date()}`,
            showColumnEditor: !1
          });
        });
      }, hideModal: () => this.setState({
        showColumnEditor: !1
      }) })
    ] });
  }
  renderPagination() {
    const {
      startIndexDisplay: t,
      endIndexDisplay: e,
      is_more: n,
      is_less: s,
      fetchNextPage: o,
      fetchPrevPage: u,
      lastResultCount: d
    } = this.store, v = {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end"
    };
    if (!(!n && !s))
      return /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx(T, {}),
        /* @__PURE__ */ i.jsx("div", { style: v, children: /* @__PURE__ */ i.jsx(me, { startIndex: t, endIndex: e, isMore: n, isLess: s, lastResultCount: d, handleNextClick: o, handlePreviousClick: u }) })
      ] });
  }
  handleColSizeChange(t) {
    const {
      columns: e
    } = this.state, {
      localStorageKey: n
    } = this.props, s = xe(e, t, n);
    this.setState({
      columns: s
    });
  }
  renderHeader(t) {
    return null;
  }
  headerRenderer() {
    const {
      localStorageKey: t
    } = this.props;
    return /* @__PURE__ */ i.jsx(be, { actions: [{
      text: "Modify columns",
      onClick: () => this.setState({
        showColumnEditor: !0
      })
    }, {
      text: "Reset table to default",
      onClick: () => {
        Ce(t), window.location.reload();
      }
    }] });
  }
  get snapToRowHeight() {
    let {
      currentList: t = []
    } = this.store;
    t || (t = []);
    const s = t.length * 40 + 32 + 16, o = 236;
    return s > o ? s : o;
  }
  get dynamicHeight() {
    const {
      height: t
    } = this.props;
    return t;
  }
  customEmptyState(t, e) {
    const n = {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column"
    };
    return /* @__PURE__ */ i.jsxs("div", { style: n, "data-testid": "empty-state", children: [
      /* @__PURE__ */ i.jsx(V, { type: e || "guided-sb-setup-inactive", factor: 8 }),
      /* @__PURE__ */ i.jsx(T, { factor: 4 }),
      /* @__PURE__ */ i.jsx(W, { type: "h3", children: t })
    ] });
  }
}
class Oe extends Dt {
  constructor(t = {}) {
    super(t), this.activeSort = null, this.activeFilters = {}, this.activeRow = null, this.enableNoParamQuery = !1, this.queryParams = {}, this.updateKey = null, this.lastResultCount = 0;
  }
  // actions
  modifyFilter(t, e, n) {
    const s = JSON.parse(JSON.stringify(this.activeFilters));
    s[t] = {
      val: e,
      type: n
    }, this.activeFilters = s;
  }
  processPaginationResponse(t = {}, e) {
    const {
      count: n,
      start_index: s,
      end_index: o,
      is_more: u,
      data: d = []
    } = t;
    u && (this.count = n), d.length && (this.start_index = s, this.end_index = o), this.lastResultCount = n, this.is_more = u, this.loadAndConstructList("items", d, e);
  }
  fetchNextPage() {
    this.start_index += this.count, this.updateKey = Math.random(), this.hydrate();
  }
  fetchPrevPage() {
    this.start_index -= this.count, this.updateKey = Math.random(), this.hydrate();
  }
  // computed
  get filteredItems() {
    return Object.keys(this.activeFilters).length ? this.items.filter((e) => {
      let n = !1;
      for (const s in this.activeFilters) {
        const o = this.activeFilters[s];
        switch (o.type) {
          case "contains":
            n = this.rowContains(e, s, o.val);
            break;
          case "starts-with":
            n = this.rowStartsWith(e, s, o.val);
            break;
          default:
            n = this.rowContains(e, s, o.val);
            break;
        }
        if (!n)
          return !1;
      }
      return !0;
    }) : this.items;
  }
  get sortedItems() {
    const t = this.activeSort ? this.activeSort : "", e = t[t.length - 1] === "-" ? "DESC" : "ASC", n = t.slice(0, t.length - 1);
    return n ? this.filteredItems.sort((s, o) => e === "DESC" ? s[n] > o[n] ? -1 : 1 : s[n] > o[n] ? 1 : -1) : this.filteredItems;
  }
  get currentList() {
    return this.sortedItems;
  }
  get validParams() {
    return Object.keys(this.queryParams).every((t) => this.queryParams[t].val);
  }
  get haveRequiredParams() {
    return Object.keys(this.queryParams).every((t) => {
      const {
        val: e,
        type: n
      } = this.queryParams[t];
      return n.includes("!") ? e : !0;
    });
  }
  //Replaces hydrateParams in ParentStore,
  //so that paginationParams are included
  get hydrateParams() {
    const t = Object.entries(this.queryParams).reduce((e, [n, s]) => (this.valDefinedOnObject(s) && (e[n] = s.val), e), {});
    return Object.assign({}, this.paginationParams, t);
  }
  // helpers
  rowContains(t = {}, e = "", n = "") {
    return String(t[e]).toUpperCase().includes(String(n).toUpperCase());
  }
  rowStartsWith(t = {}, e = "", n = "") {
    return String(t[e]).toUpperCase().startsWith(String(n).toUpperCase());
  }
}
at(Oe, {
  // values
  activeSort: j,
  activeFilters: j,
  activeRow: j,
  queryParams: j,
  updateKey: j,
  lastResultCount: j,
  // actions
  modifyFilter: b.bound,
  processPaginationResponse: b.bound,
  fetchNextPage: b.bound,
  fetchPrevPage: b.bound,
  // computed
  filteredItems: E,
  sortedItems: E,
  currentList: E,
  hydrateParams: E
});
const $e = "_wrap_ibxb1_1", De = "_circle_ibxb1_5", ke = "_text_ibxb1_11", Ue = "_restyled_ibxb1_19", Le = "_capitalized_ibxb1_26", We = "_uppercase_ibxb1_30", He = "_success_ibxb1_34", qe = "_pending_ibxb1_40", Ne = "_warning_ibxb1_43", Fe = "_error_ibxb1_46", Ve = "_draft_ibxb1_49", k = {
  wrap: $e,
  circle: De,
  text: ke,
  restyled: Ue,
  capitalized: Le,
  uppercase: We,
  success: He,
  default: "_default_ibxb1_37",
  pending: qe,
  warning: Ne,
  error: Fe,
  draft: Ve
}, Be = {
  ACTIVE: "success",
  CLEARED: "success",
  ENABLED: "success",
  SUCCESS: "success",
  UNVERIFIED: "default",
  COMPLETION: "default",
  REQUESTED: "draft",
  REQUEST_DECLINED: "error",
  LIMITED: "warning",
  PARTIAL: "warning",
  PENDING: "warning",
  ERROR: "error",
  SUSPENDED: "warning",
  DECLINED: "error",
  DISABLED: "draft",
  UNACTIVATED: "draft",
  CLOSED: "draft",
  INACTIVE: "draft",
  TERMINATED: "error",
  DECISION_GREEN: "success",
  DECISION_YELLOW: "warning",
  DECISION_RED: "danger",
  REJECTED: "danger",
  PROVISIONED: "success"
};
class ht extends Ot {
  constructor(...t) {
    super(...t), this.renderDisplayText = () => {
      const {
        onlyDisplayChildren: e,
        children: n,
        status: s
      } = this.props, o = typeof s == "string" ? s.toLowerCase() : "", u = o && o.charAt(0).toUpperCase() + o.slice(1).replace(/_/g, " ");
      return e ? n : u && n ? `${u}${n}` : u || "";
    }, this.getStatusClass = () => {
      const {
        status: e
      } = this.props, n = typeof e == "string" ? e.toUpperCase() : "";
      return Be[n];
    };
  }
  render() {
    let {
      testId: t,
      uppercase: e,
      textType: n,
      restyled: s
    } = this.props;
    const o = this.getStatusClass();
    return /* @__PURE__ */ i.jsxs("div", { className: k.wrap, children: [
      /* @__PURE__ */ i.jsx("div", { className: `${k.circle} ${k[o]}` }),
      /* @__PURE__ */ i.jsx(B, {}),
      /* @__PURE__ */ i.jsx(W, { type: n, testId: `${t}_status-text`, children: /* @__PURE__ */ i.jsx("div", { className: `${n || k.text} ${e ? k.uppercase : k.capitalized} ${s ? k.restyled : ""}`, children: this.renderDisplayText() }) })
    ] });
  }
}
ht.propTypes = {
  onlyDisplayChildren: h.bool,
  status: h.string,
  testId: h.string,
  uppercase: h.bool,
  textType: h.string
};
ht.defaultProps = {
  onlyDisplayChildren: !1,
  status: null,
  testId: "volt-status",
  uppercase: !1
};
const Me = ht, Ye = "_tabWrap_s8yix_1", ze = "_wrap_s8yix_12", Qe = "_tab_s8yix_1", Ke = "_active_s8yix_32", Je = "_action_s8yix_43", Ge = "_iconHighlight_s8yix_61", Xe = "_actionsWrap_s8yix_71", Ze = "_actionsControl_s8yix_77", tr = "_chevron_s8yix_82", O = {
  tabWrap: Ye,
  wrap: ze,
  tab: Qe,
  active: Ke,
  action: Je,
  iconHighlight: Ge,
  actionsWrap: Xe,
  actionsControl: Ze,
  chevron: tr
};
class Ut extends Ot {
  get activeTabs() {
    const {
      tabs: t
    } = this.props;
    if (Array.isArray(t))
      return t;
    const e = [];
    for (let n in t)
      t[n] && e.push(n);
    return e;
  }
  renderTabs() {
    const {
      onClick: t,
      activeTab: e,
      testId: n
    } = this.props, s = this.activeTabs.map((o, u) => {
      const d = o === e;
      return /* @__PURE__ */ i.jsx("div", { onClick: () => t && t(o), className: `${O.tab} ${d ? O.active : ""}`, title: o, "data-testid": `${n}_tab-${o}`, children: o }, u);
    });
    return /* @__PURE__ */ i.jsx("div", { className: O.tabWrap, children: s });
  }
  renderActions() {
    const {
      actions: t,
      row: e,
      testId: n
    } = this.props;
    if (!t || t.length === 0)
      return null;
    const s = t.map((o) => {
      const {
        element: u,
        icon: d,
        text: v,
        onClick: y
      } = o;
      return u || {
        element: /* @__PURE__ */ i.jsxs("div", { className: O.action, "data-testid": `${n}_action-${v}`, children: [
          /* @__PURE__ */ i.jsx("div", { className: O.iconHighlight, children: /* @__PURE__ */ i.jsx(V, { factor: 0.2, mod: "reversed", type: d }) }),
          /* @__PURE__ */ i.jsx(B, { factor: 1.5 }),
          v
        ] }),
        onClick: () => y && y(e)
      };
    });
    return /* @__PURE__ */ i.jsx("div", { className: O.actionsWrap, "data-testid": `${n}_action-dropdown`, children: /* @__PURE__ */ i.jsx(he, { control: /* @__PURE__ */ i.jsx(U, { type: "outline", testId: "tab-selector-actions-volt-button", children: /* @__PURE__ */ i.jsxs("div", { className: O.actionsControl, children: [
      /* @__PURE__ */ i.jsx("div", { children: "Actions" }),
      /* @__PURE__ */ i.jsx(B, { factor: 0.5 }),
      /* @__PURE__ */ i.jsx("div", { className: O.chevron, children: /* @__PURE__ */ i.jsx(V, { type: "chevron-down", mod: "disabled", overrideColor: "#5F5F7A", factor: 0.8333 }) })
    ] }) }), content: s }) });
  }
  render() {
    const {
      testId: t
    } = this.props;
    return /* @__PURE__ */ i.jsxs("div", { className: O.wrap, "data-testid": t, children: [
      this.renderTabs(),
      this.renderActions()
    ] });
  }
}
Ut.propTypes = {
  tabs: h.any,
  activeTab: h.string,
  actions: h.array,
  onClick: h.func,
  testId: h.string
};
Ut.defaultProps = {
  activeTab: "",
  tabs: [],
  actions: [],
  onClick: () => {
  },
  testId: "tab-selector"
};
const er = "_label_1qr4i_1", rr = "_text_1qr4i_6", It = {
  label: er,
  text: rr
}, nr = M(({
  children: c
}) => c && c.map ? c.map((t, e, n) => {
  const s = e !== n.length - 1, o = typeof t == "string";
  return /* @__PURE__ */ i.jsxs("div", { children: [
    o ? /* @__PURE__ */ i.jsx(W, { children: t }, `${t}_${e}`) : t,
    s && /* @__PURE__ */ i.jsx(T, {})
  ] }, e);
}) : c);
function ft({
  children: c,
  label: t,
  hidden: e,
  testId: n
}) {
  const s = c instanceof Array && !c.length;
  if (!c || e || s)
    return null;
  let o = {
    display: "flex"
  };
  return (typeof c == "string" || Array.isArray(c) && c.length === 1) && (o.alignItems = "center"), /* @__PURE__ */ i.jsxs("div", { "data-testid": `${n}_label-${t}`, children: [
    /* @__PURE__ */ i.jsxs("div", { style: o, children: [
      /* @__PURE__ */ i.jsx("div", { className: It.label, children: /* @__PURE__ */ i.jsx(W, { type: "h6", children: t }) }),
      /* @__PURE__ */ i.jsx("div", { className: It.text, children: /* @__PURE__ */ i.jsx(nr, { children: c }) })
    ] }),
    /* @__PURE__ */ i.jsx(T, { factor: 2 })
  ] });
}
ft.propTypes = {
  children: h.any,
  label: h.any,
  hidden: h.bool,
  testId: h.string
};
ft.defaultProps = {
  children: null,
  label: null,
  hidden: !1,
  testId: "detail-snippet"
};
const _r = M(ft);
export {
  Se as ActiveField,
  _r as DetailSnippetRow,
  fr as ErrorBannerAlert,
  pr as InfoCard,
  ct as InfoFieldItem,
  Ae as InfoFieldList,
  Dt as PaginationStore,
  kt as ParentComponent,
  vr as ParentDetail,
  gr as ParentDetailCard,
  $t as ParentStore,
  yr as ParentTable,
  Oe as ParentTableStore,
  Ie as SegmentTrackHOC,
  Me as Status,
  Ut as TabSelector,
  hr as containerHeightHOC,
  dr as containerWidthHOC,
  Te as segmentTrackEvent
};
